import React from 'react';
import Styles from './styles.module.css';
import { ReactComponent as UploadSvg } from '../../assets/svg/uploadIcon.svg'
/**
 * Component responsible for handling files via drag or drag&drop.
 *
 * @param getRootProps
 * @param getInputProps
 * @param isDragActive
 * @returns {JSX.Element}
 * @constructor
 */
const EDIDropzone = ({ getRootProps, getInputProps, isDragActive }) => {
    return (
        <div className={Styles.wrapper}>
            {/* Upload Section Header */}
            <div className={Styles.uploadSection}>
                <h4>EDI Datei auswählen</h4>
                <div {...getRootProps()} className={Styles.dropContent} >
                    <input {...getInputProps()} />
                    <div className={Styles.uploadContent}>
                        <UploadSvg className={Styles.uploadIcon} />
                        {isDragActive ? (
                            <p>EDI Datei hier ablegen...</p>
                        ) : (
                            <p>
                                <span className={Styles.clickText}>EDI Datei hochladen</span>
                                <span> (oder per Drag&Drop)</span>
                            </p>
                        )}
                    </div>
                </div>
            </div>
            <div className={Styles.version}>version: 2024.1811.1</div>
        </div>
    )
};

export default EDIDropzone;